import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { IoAttach, IoSync } from "react-icons/io5";
import { Tooltip as ReactTooltip } from "react-tooltip";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";

import * as callActions from "../../actions/callActions";
import * as modalActions from "../../actions/modalActions";
import * as expenseActions from "../../actions/expenseActions";

import Checkbox from "./ExpenseApprovalCheckbox";

import TableActions from "../common/TableActions";
import FileService from "../../services/fileService";
import { formatDate } from "../../helpers/date";

const ExpenseApprovalContainer = ({
  billed,
  reimbursed,
  expense,
  codes,
  onMarkAsComplete,
  updateExpense,
  onClickView,
  onClickDelete,
  auth
}) => {
  const [approved, setApproved] = useState("");
  const [stateBilled, setStateBilled] = useState(false);
  const [stateReimbursed, setStateReimbursed] = useState(false);
  const [stateBillToCust, setStateBillToCust] = useState(false);
  const [stateReimburseToEmp, setStateReimburseToEmp] = useState(false);

  const token = localStorage.getItem("grav_token");

  useEffect(() => {
    setStateBilled(billed);
  }, [billed]);

  useEffect(() => {
    setStateReimbursed(reimbursed);
  }, [reimbursed]);

  useEffect(() => {
    setStateBillToCust(expense.bill_to_customer);
    setStateReimburseToEmp(expense.reimburse_to_employee);
  }, [expense]);

  const onClickComplete = () => {
    const completedStatus = codes?.find(
      (c) => c.label === "Completed" && c.entity === "Expenses"
    );

    const newExpense = {
      ...expense,
      category: expense.category._id,
      customer: expense.customer._id,
      employee: expense.employee._id || expense.employee,
      status: completedStatus.id
    };

    onMarkAsComplete(newExpense);
  };

  const checkApproved = async () => {
    let newExpenseStatus;
    const statusCode = {
      submittedStatus: codes?.find(
        (c) => c.label === "Submitted" && c.entity === "Expenses"
      ),
      approvedStatus: codes?.find(
        (c) => c.label === "Approved" && c.entity === "Expenses"
      ),
      completedStatus: codes?.find(
        (c) => c.label === "Completed" && c.entity === "Expenses"
      )
    };
    if (approved === true) {
      newExpenseStatus = statusCode?.submittedStatus;
      setApproved(false);
    } else if (approved === false) {
      newExpenseStatus = statusCode?.approvedStatus;
      setApproved(true);
    } else if (approved === "") {
      if (expense.status._id === statusCode?.submittedStatus?.id) {
        newExpenseStatus = statusCode?.approvedStatus;
        setApproved(true);
      } else if (expense.status._id === statusCode?.approvedStatus?.id) {
        newExpenseStatus = statusCode?.submittedStatus;
        setApproved(false);
      }
    }

    const newExpense = {
      ...expense,
      status: newExpenseStatus,
      category: expense.category,
      customer: expense.customer,
      employee: expense.employee._id || expense.employee
    };
    updateExpense(newExpense);
  };

  const checkBilled = () => {
    const newExpense = {
      ...expense,
      to_customer_complete: !stateBilled,
      category: expense.category,
      customer: expense.customer,
      employee: expense.employee._id || expense.employee
    };
    setStateBilled(!stateBilled);
    updateExpense(newExpense);
  };

  const checkReimbursed = () => {
    const newExpense = {
      ...expense,
      to_employee_complete: !stateReimbursed,
      category: expense.category,
      customer: expense.customer,
      employee: expense.employee._id || expense.employee
    };
    setStateReimbursed(!stateReimbursed);
    updateExpense(newExpense);
  };

  const checkBill = () => {
    const newExpense = {
      ...expense,
      bill_to_customer: !stateBillToCust,
      category: expense.category,
      customer: expense.customer,
      employee: expense.employee._id || expense.employee
    };
    setStateBillToCust(!stateBillToCust);
    updateExpense(newExpense);
  };

  const checkReimburse = () => {
    const newExpense = {
      ...expense,
      reimburse_to_employee: !stateReimburseToEmp,
      category: expense.category,
      customer: expense.customer,
      employee: expense.employee._id || expense.employee
    };
    setStateReimburseToEmp(!stateReimburseToEmp);
    updateExpense(newExpense);
  };

  const handleAttachmentClick = async (path) => {
    const fileName = path?.replace("https://gfs-redkeep.s3.amazonaws.com/", "");
    const imageSource = await FileService.getFileWithToken(fileName, token);

    window.open(imageSource);
  };

  const status = {
    submittedStatus: codes?.find(
      (c) => c.label === "Submitted" && c.entity === "Expenses"
    ),
    approvedStatus: codes?.find(
      (c) => c.label === "Approved" && c.entity === "Expenses"
    ),
    completedStatus: codes?.find(
      (c) => c.label === "Completed" && c.entity === "Expenses"
    )
  };
  // set status
  let expenseStatus;
  if (approved === true) {
    expenseStatus = true;
  } else if (approved === false) {
    expenseStatus = false;
  } else if (
    !approved &&
    status.submittedStatus &&
    status.approvedStatus &&
    status.completedStatus
  ) {
    if (expense.status._id === status.submittedStatus.id) {
      expenseStatus = false;
    } else if (
      expense?.status?._id === status?.approvedStatus?.id ||
      expense?.status?._id === status?.completedStatus?.id
    ) {
      expenseStatus = true;
    }
  }

  let allowComplete = false;
  if (expense?.status?._id !== status?.completedStatus?.id) {
    if (
      (!expense.bill_to_customer ||
        (expense.bill_to_customer && expense.to_customer_complete)) &&
      (!expense.reimburse_to_employee ||
        (expense.reimburse_to_employee && expense.to_employee_complete)) &&
      expenseStatus === true
    ) {
      allowComplete = true;
    }
  }

  return (
    <React.Fragment>
      <div className="expense-approval-container">
        <div>
          <Row
            className="expense-approval-main"
            style={{
              fontWeight: "bold"
            }}
          >
            <Col md={1}>
              <div className="date">{formatDate(expense.date, "MM/dd/yy")}</div>
            </Col>
            <Col md={2}>
              <div className="name">{expense.employee.full_name}</div>
            </Col>
            <Col md={2}>
              <div
                className="customer"
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap"
                }}
              >
                {expense?.customer?.name}{" "}
              </div>
            </Col>
            <Col md={1}>
              <div className="category">{expense.category.label}</div>
            </Col>
            <Col md={1}>
              <div className="total">${expense.total.toFixed(2)}</div>
            </Col>
            <Col md={2}>
              <div>
                Bill To Customer:
                <select
                  className={`table-select ${
                    auth.isNightMode ? "dark-select" : ""
                  }`}
                  value={stateBillToCust}
                  onChange={checkBill}
                  style={{ border: "none", backgroundColor: "transparent" }}
                >
                  <option value>YES</option>
                  <option value={false}>NO</option>
                </select>
              </div>
            </Col>
            <Col md={3}>
              <div>
                Reimburse Employee:
                <select
                  className={`table-select ${
                    auth.isNightMode ? "dark-select" : ""
                  }`}
                  value={stateReimburseToEmp}
                  onChange={checkReimburse}
                  style={{ border: "none", backgroundColor: "transparent" }}
                >
                  <option value>YES</option>
                  <option value={false}>NO</option>
                </select>
              </div>
            </Col>
          </Row>
          <Row
            className="expense-approval-description"
            style={{
              textAlign: "left"
            }}
          >
            <Col
              md={6}
              style={{
                textAlign: "center",
                borderRight: "1px solid #efefef"
              }}
            >
              {expense.description}
              <div>
                {expense.receipt && (
                  <React.Fragment>
                    <button
                      id={`attachment-${expense._id}`}
                      className="btn"
                      data-tooltip-content="View attachment"
                      data-tooltip-variant={auth.isNightMode ? "dark" : "light"}
                      data-html={false}
                      data-for="info"
                      rel="noopener noreferrer"
                      target="_blank"
                      style={{
                        background: "transparent"
                      }}
                      onClick={() =>
                        handleAttachmentClick(expense.receipt.path)
                      }
                    >
                      <IoAttach size={20} style={{ color: "#50accb" }} />
                    </button>
                    <ReactTooltip
                      anchorId={`attachment-${expense._id}`}
                      className={`custom-tooltip ${
                        auth.isNightMode ? "dark" : "light"
                      }`}
                      place="bottom"
                      type={auth.isNightMode ? "dark" : "light"}
                      effect="solid"
                      globalEventOff="click"
                    />
                  </React.Fragment>
                )}
                {expense.occurs_annually && (
                  <React.Fragment>
                    <a
                      id={`annually-${expense._id}`}
                      data-tooltip-content="Occurs Annually"
                      data-tooltip-variant={auth.isNightMode ? "dark" : "light"}
                      data-html={false}
                      data-for="info"
                      data-event="click"
                      style={{ paddingRight: 5 }}
                    >
                      <IoSync size={20} style={{ color: "#50accb" }} />
                    </a>
                    <ReactTooltip
                      anchorId={`annually-${expense._id}`}
                      className={`custom-tooltip ${
                        auth.isNightMode ? "dark" : "light"
                      }`}
                      place="bottom"
                      type={auth.isNightMode ? "dark" : "light"}
                      effect="solid"
                      globalEventOff="click"
                    />
                  </React.Fragment>
                )}
              </div>
            </Col>
            <Col md={2}>
              <Checkbox
                className="checkbox expense"
                style={{ margin: "0 0" }}
                onClickCheck={checkApproved}
                checked={expenseStatus}
                disabled={expense.status._id === status.completedStatus?.id}
              />
              <div style={{ display: "inline" }}>Approved</div>
            </Col>
            <Col md={2}>
              <Checkbox
                className="checkbox"
                style={{ margin: "none" }}
                onClickCheck={checkBilled}
                checked={stateBilled}
                disabled={
                  !expense.bill_to_customer ||
                  expense.status._id === status.completedStatus?.id
                }
              />
              <div
                style={
                  expense.bill_to_customer
                    ? { display: "inline" }
                    : { color: "#b8bac5", display: "inline" }
                }
              >
                Billed To Customer
              </div>
            </Col>
            <Col md={2}>
              <Checkbox
                className="checkboxRED"
                style={{ margin: "none" }}
                onClickCheck={checkReimbursed}
                checked={stateReimbursed}
                disabled={
                  !expense.reimburse_to_employee ||
                  expense.status._id === status.completedStatus?.id
                }
                label="Reimbursed Employee"
              />
              <div
                style={
                  expense.reimburse_to_employee
                    ? { display: "inline" }
                    : { color: "#b8bac5", display: "inline" }
                }
              >
                Reimbursed Employee
              </div>
            </Col>
          </Row>
        </div>
        <div className="expense-approval-actions">
          <TableActions
            onClickView={() => onClickView(expense._id)}
            onClickDelete={() => onClickDelete(expense._id)}
            onClickComplete={allowComplete ? () => onClickComplete() : null}
            viewText="View Full Expense"
            deleteText="Delete Expense"
          />
        </div>
      </div>
    </React.Fragment>
  );
};

ExpenseApprovalContainer.propTypes = {
  billed: PropTypes.bool,
  reimbursed: PropTypes.bool,
  expense: PropTypes.object,
  updateExpense: PropTypes.func,
  codes: PropTypes.array,
  onClickView: PropTypes.func,
  onClickDelete: PropTypes.func,
  employee: PropTypes.object,
  auth: PropTypes.object.isRequired,
  onMarkAsComplete: PropTypes.func
};
function mapStatesToProps(state) {
  return {
    callToSave: state.reducers.callToSave
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...modalActions, ...callActions, ...expenseActions },
      dispatch
    )
  };
}

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(ExpenseApprovalContainer);
